
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTrackOn as ObiTrackOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-track-on.js';
 
 
 

 
 export const ObiTrackOn = createComponent({
   react: React,
   tagName: 'obi-track-on',
   elementClass: ObiTrackOnElement,
   events: {
     
   }
  });
 
 